import { Card, Typography, Box, Divider } from "@mui/material";

export default function WelcomePage() {
    return (
        <Box
            sx={{
                bgcolor: "#CCACDC",
                height: "100vh",
                position: "relative",
            }}
        >
            <Card
                sx={{
                    position: "absolute",
                    top: "100px",
                    left: "350px",
                    width: "480px",
                    height: "400px",
                    borderRadius: "8px",
                    border: "0.5px solid #ddd",
                    boxShadow: 3,
                    textAlign: "center",
                    px: 4,
                    pt: "80px", // Top gap to "Welcome to the"
                    boxSizing: "border-box",
                }}
            >
                <Typography
                    sx={{
                        fontFamily: "Roboto",
                        fontWeight: 400,
                        fontSize: "22px",
                        color: "#8031A7",
                        mb: "20px", // Gap to "DYL Admin hub"
                    }}
                >
                    Welcome to the
                </Typography>

                <Typography
                    sx={{
                        fontFamily: "Roboto",
                        fontWeight: 300,
                        fontSize: "44px",
                        color: "#8031A7",
                        mb: "16px", // Gap to Divider
                    }}
                >
                    DYL Admin hub
                </Typography>

                <Divider sx={{ mb: "40px", mx: "auto", borderBottom: "1px solid #8031A7", width: "75%" }} />

                <Typography
                    sx={{
                        fontFamily: "Roboto",
                        fontWeight: 400,
                        fontSize: "18px",
                        color: "#333",
                        lineHeight: "140%",
                        textAlign: "center",
                        mb: "60px", // Bottom gap to match card height
                    }}
                >
                    Use the navigation menu on <br />
                    the left to get started
                </Typography>
            </Card>
        </Box>
    );
}